// src/pages/SaoLourencoPage/SaoLourencoPage.jsx

import React from 'react';
import './SaoLourencoPage.css';

const SaoLourencoPage = () => {
  return (
    <div className="sl-page-container">
      {/* === HERO HEADER === */}      
        <div className="section-header">
            <span className="section-eyebrow">Descubra São Lourenço</span>
            <h1 className="section-title">Um Destino de Sensações</h1>
            
        </div>

      {/* === BLOCO 1: PARQUE DAS ÁGUAS === */}
      <div className="attraction-block">
        <div className="attraction-image">
          <img src="/images/SaoLourencoPage/parque.webp" alt="Parque das Águas de São Lourenço" />
        </div>
        <div className="attraction-text">
          <h3>Parque das Águas</h3>
          <p>
            O coração de São Lourenço e um dos mais belos parques do Brasil. Caminhe por seus jardins impecáveis, admire os lagos serenos e, acima de tudo, experimente as nove fontes de águas minerais, cada uma com propriedades terapêuticas únicas. É um convite à saúde, ao bem-estar e à contemplação da natureza.
          </p>
        </div>
      </div>

      {/* === BLOCO 2: TREM DAS ÁGUAS === */}
      <div className="attraction-block">
        <div className="attraction-image">
          <img src="/images/SaoLourencoPage/trem-das-aguas.webp" alt="Trem das Águas - Maria Fumaça" />
        </div>
        <div className="attraction-text">
          <h3>Trem das Águas</h3>
          <p>
            Embarque em uma charmosa viagem ao passado a bordo da autêntica locomotiva a vapor, a "Maria Fumaça". O percurso de 10 km até Soledade de Minas revela paisagens deslumbrantes da Serra da Mantiqueira, ao som de música regional ao vivo. Uma experiência nostálgica e encantadora para todas as idades.
          </p>
        </div>
      </div>

      {/* --- NOVO BLOCO: BALONISMO --- */}
      <div className="attraction-block">
        <div className="attraction-image">
          <img src="/images/SaoLourencoPage/balonismo.webp" alt="Passeio de balão sobre a Serra da Mantiqueira" />
        </div>
        <div className="attraction-text">
          <h3>Céus de São Lourenço</h3>
          <p>
            Viva uma experiência verdadeiramente inesquecível flutuando sobre a cidade em um majestoso balão de ar quente. Tenha uma perspectiva única do Parque das Águas e aprecie as vistas deslumbrantes da Serra da Mantiqueira ao nascer ou pôr do sol. Uma aventura serena que marca a memória.
          </p>
        </div>
      </div>

      {/* === BLOCO 4: GASTRONOMIA MINEIRA === */}
      <div className="attraction-block">
        <div className="attraction-image">
          <img src="/images/SaoLourencoPage/gastronomia.webp" alt="Gastronomia Mineira - Pão de Queijo e Café" />
        </div>
        <div className="attraction-text">
          <h3>Sabores da Mantiqueira</h3>
          <p>
            A gastronomia de São Lourenço é um capítulo à parte. Delicie-se com o autêntico pão de queijo, doces de leite artesanais, queijos premiados, cafés especiais e cachaças de alambique. Cada sabor conta uma história da rica tradição culinária de Minas Gerais, uma festa para o paladar.
          </p>
        </div>
      </div>

       {/* === BLOCO 5: ARTESANATO LOCAL === */}
       <div className="attraction-block">
        <div className="attraction-image">
          <img src="/images/SaoLourencoPage/artesanato.webp" alt="Artesanato local de Minas Gerais" />
        </div>
        <div className="attraction-text">
          <h3>Artesanato e Cultura</h3>
          <p>
            Leve para casa uma lembrança autêntica da sua viagem. O artesanato local é rico em trabalhos com madeira, cerâmica, bordados e tecelagem. Explore as feiras e lojas da cidade para encontrar peças únicas que expressam a cultura e a criatividade do povo mineiro.
          </p>
        </div>
      </div>

      {/* === CALL TO ACTION FINAL === */}
      <div className="sl-cta-container">
        <h2>Pronto para Viver Essas Experiências?</h2>
        <p>Sua jornada inesquecível em São Lourenço começa no conforto do Alzira Imperial Hotel.</p>
        <a href="https://wa.me/+5535988171649" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              Faça sua Reserva
            </a>
      </div>
    </div>
  );
};

export default SaoLourencoPage;